import { render, staticRenderFns } from "./CreditpushMainLayout.vue?vue&type=template&id=0420cd5a&scoped=true"
import script from "./CreditpushMainLayout.vue?vue&type=script&lang=ts"
export * from "./CreditpushMainLayout.vue?vue&type=script&lang=ts"
import style0 from "./CreditpushMainLayout.vue?vue&type=style&index=0&id=0420cd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0420cd5a",
  null
  
)

export default component.exports